var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscoverLightLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discover-light-large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "card_bg",
    d: "M48,4V28a4,4,0,0,1-4,4H4a3.81,3.81,0,0,1-1.36-.24A4,4,0,0,1,0,28V4A4,4,0,0,1,4,0H44A4,4,0,0,1,48,4Z",
    fill: "#dfe3e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discover",
    transform: "translate(2 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M46,0V11.965A4.046,4.046,0,0,1,41.944,16H1.379A3.882,3.882,0,0,1,0,15.758c3.407-.484,6.693-1.09,9.918-1.776.852-.161,1.683-.363,2.515-.545C25.84,10.391,37.441,5.912,43.972,1.513,44.7,1.009,45.392.5,46,0Z",
    transform: "translate(0 6)",
    fill: "#ee7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.019,6.414c-.066,0-.133,0-.2-.006H0V.049H1.82V.008C1.9,0,1.981,0,2.053,0A3.22,3.22,0,0,1,4.12,5.688,3.422,3.422,0,0,1,2.019,6.414ZM1.26,1.129v4.28h.32c.067.006.135.009.2.009A2.307,2.307,0,0,0,3.3,4.848a2.14,2.14,0,0,0,.7-1.6,2.106,2.106,0,0,0-.7-1.6,2.334,2.334,0,0,0-1.72-.52Z",
    transform: "translate(2 0.592)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 1.25,
    height: 6.42,
    transform: "translate(7.85 0.63)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M2.65,2.574c-.75-.27-1-.46-1-.81a.856.856,0,0,1,.93-.71,1.33,1.33,0,0,1,1,.52l.65-.85A2.75,2.75,0,0,0,2.35,0a1.88,1.88,0,0,0-2,1.84c0,.89.4,1.34,1.57,1.76a5.14,5.14,0,0,1,.87.37.76.76,0,0,1,.38.66.92.92,0,0,1-1,.91,1.48,1.48,0,0,1-1.36-.86L0,5.464a2.49,2.49,0,0,0,2.28,1.22,2.06,2.06,0,0,0,2.2-2.1C4.48,3.564,4.07,3.094,2.65,2.574Z",
    transform: "translate(9.52 0.516)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M0,3.36A3.32,3.32,0,0,0,3.39,6.71a3.43,3.43,0,0,0,1.57-.37V4.87a2,2,0,0,1-1.51.7A2.11,2.11,0,0,1,1.29,3.35a2.13,2.13,0,0,1,2.1-2.2,2.09,2.09,0,0,1,1.57.72V.4A3.19,3.19,0,0,0,3.42,0,3.38,3.38,0,0,0,0,3.36Z",
    transform: "translate(14.41 0.48)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M3.08,4.31,1.36,0H0L2.72,6.58h.67L6.17,0H4.81L3.08,4.31Z",
    transform: "translate(26.22 0.63)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M0,6.42H3.56V5.33H1.25V3.6H3.47V2.51H1.25V1.09H3.56V0H0V6.42Z",
    transform: "translate(32.95 0.63)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M1.26,6.361H0V0H1.84C3.289,0,4.12.685,4.12,1.88A1.738,1.738,0,0,1,2.66,3.72l2,2.639-1.519,0L1.4,3.82H1.26V6.36ZM1.26,1V2.94h.4c.795,0,1.181-.308,1.181-.94,0-.663-.4-1-1.181-1Z",
    transform: "translate(37.34 0.64)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M6.82,3.41A3.41,3.41,0,1,1,3.41,0,3.41,3.41,0,0,1,6.82,3.41Z",
    transform: "translate(19.77 0.43)",
    fill: "#ee7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M.14.581H0V0H.2C.344,0,.42.062.42.18A.152.152,0,0,1,.3.32L.479.578.32.58.14.34V.58Z",
    transform: "translate(41.7 0.58)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M.5,1A.5.5,0,0,1,.48,0H.5a.5.5,0,0,1,.347.14A.5.5,0,0,1,.5,1ZM.48.121A.38.38,0,0,0,.1.5a.391.391,0,0,0,.38.42H.488A.319.319,0,0,0,.74.8.457.457,0,0,0,.86.5.381.381,0,0,0,.48.121Z",
    transform: "translate(41.46 0.36)",
    fill: "#231f20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverLightLarge);
export default __webpack_public_path__ + "static/media/discover-light-large.495b9c2ac7de428981c3f9a815f3da25.svg";
export { ForwardRef as ReactComponent };